// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e8661a29","488":"ac492ba3","787":"af4add3a","871":"5d033d1f"}[chunkId] + ".chunk.js";
};